'use strict';

exports.atob = self.atob.bind(self);
exports.btoa = self.btoa.bind(self);



//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-base64/browser.js
// module id = 369
// module chunks = 172923708597564 175449915206275